import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Le misure del testo di tailwind.config.ts che Tailwind non ha di suo: senza,
// twMerge le prende per colori e le toglie accanto a un `text-ink-*`.
const twMerge = extendTailwindMerge({
  extend: { classGroups: { "font-size": [{ text: ["md", "micro", "label", "data", "headline"] }] } },
});

/** Tailwind class merger — used by every shadcn primitive. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
